module.exports = __webpack_public_path__ + "static/media/Inter.var-latin.1b0de76b.woff2";